module.exports = __webpack_public_path__ + "img/common.9faeb2e9.svg";